<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">活动订单编辑</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <div style="
            display: flex;
            align-items: center;
            justify-content: flex-start;
          ">
          <div class="top-select-title" :class="{ active: selectItemFlag === item.value }" v-for="item in selectListArr"
            :key="item.value" @click="handleClickItem(item)">
            {{ item.label }}
          </div>
        </div>

        <div v-if="selectItemFlag === '1'">
          <div class="flex-orderno-line-div">
            <div class="line-child-order-no-title">订单编号</div>
            <div class="line-child-order-no-value">
              {{ detailForm.activityOrderNo || "-" }}
            </div>
            <div class="line-child-submit-btns-div">
              <button class="common-bg-button margin-r-10" @click="onPileSwapInitiate"
                v-if="detailForm.activityOrderStatus === 'IN_USE' || detailForm.activityOrderStatus === 'PAUSE'"
                style="background: #409EFF;border-color: #409EFF;">售后换桩</button>
              <button class="common-bg-button margin-r-10" @click="onPileSwapCancel"
                v-if="detailForm.activityOrderStatus === 'SWAPPING' && !detailForm.swapUnbound"
                style="background: #E6A23C;border-color: #E6A23C;">取消换桩</button>
              <button class="common-bg-button margin-r-10"
                v-if="detailForm.activityOrderStatus === 'SWAPPING' && detailForm.swapUnbound"
                style="background: #C0C4CC;border-color: #C0C4CC;cursor:not-allowed;" disabled>取消换桩</button>
              <button class="common-bg-button margin-r-10" @click="submit()">
                保 存
              </button>
              <button class="common-bg-button" @click="back()">
                返 回
              </button>
            </div>
          </div>

          <!-- 订单基本信息 -->
          <el-row :gutter="20">
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">用户姓名：</div>
              <div class="cust-detail-value">
                {{
                  detailForm.activityOrder ? detailForm.activityOrder.name : "-"
                }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">用户手机号：</div>
              <div class="cust-detail-value">
                <span style="margin-right: 8px" v-if="isFlag">{{
                  detailForm.activityOrder
                    ? detailForm.activityOrder.mobile
                    : "-"
                }}</span>
                <span style="margin-right: 8px" v-else>
                  {{
                    detailForm.activityOrder.mobile
                      ? detailForm.activityOrder.mobile.replace(
                        detailForm.activityOrder.mobile.substring(2, 9),
                        "*******"
                      )
                      : "-"
                  }}
                </span>
                <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_隐藏.png" alt=""
                  v-if="isFlag == false" @click="flagChange()" />
                <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_显示.png" alt=""
                  v-if="isFlag == true" @click="flagChange()" />
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">报名创建时间：</div>
              <div class="cust-detail-value">
                {{ detailForm.createdWhen || "-" }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">是否下发签约短信：</div>
              <div class="cust-detail-value">
                <el-select v-model="detailForm.signFlag" size="small" clearable class="full-width" placeholder="请选择是否下发"
                  @change="signChage">
                  <el-option label="是" value="Y" />
                  <el-option label="否" value="N" />
                </el-select>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">不签约/不安装原因：</div>
              <div class="cust-detail-value">
                <el-select v-model="detailForm.installFailReason" size="small" clearable class="full-width"
                  placeholder="请选择不安装原因">
                  <el-option label="报装困难" value="报装困难" />
                  <el-option label="电源点问题" value="电源点问题" />
                  <el-option label="无固定车位" value="无固定车位" />
                  <el-option label="报装未完成" value="报装未完成" />
                  <el-option label="无安装条件内" value="无安装条件内" />
                  <el-option label="增项费用高" value="增项费用高" />
                  <el-option label="活动复杂不易懂" value="活动复杂不易懂" />
                  <el-option label="暂时没有充电桩需求" value="暂时没有充电桩需求" />
                  <el-option label="随便点点" value="随便点点" />
                  <el-option label="不认可用户协议" value="不认可用户协议" />
                  <el-option label="不认可免押协议" value="不认可免押协议" />
                  <el-option label="物业问题" value="物业问题" />
                  <el-option label="不划算" value="不划算" />
                  <el-option label="未操作过报名" value="未操作过报名" />
                  <el-option label="产品与需求不符" value="产品与需求不符" />
                  <el-option label="其他" value="其他" />
                </el-select>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">不签约/不安装原因时间：</div>
              <div class="cust-detail-value">
                {{ detailForm.installFailReasonTime || "-" }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">待签约短信下发时间：</div>
              <div class="cust-detail-value">
                <el-date-picker v-model="detailForm.signMessageSendTime" type="datetime" placeholder="请选择待签约短信下发时间"
                  value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" :picker-options="pickerOptions" size="small" />
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">报名渠道</div>
              <div class="cust-detail-value">
                <el-select v-model="detailForm.channel" size="small" clearable disabled class="full-width"
                  placeholder="请选择报名渠道">
                  <el-option label="微信" :value="0" />
                  <el-option label="支付宝(私域)" :value="1" />
                  <el-option label="小红书" :value="2" />
                  <el-option label="抖音" :value="3" />
                  <el-option label="支付宝公充" :value="4" />
                  <el-option label="家充位置" :value="5" />
                  <el-option label="app" :value="6" />
                  <el-option label="桩到家微信小程序" :value="7" />
                  <el-option label="桩到家支付宝小程序" :value="8" />
                  <el-option label="桩到家" :value="9" />
                  <el-option label="桩到家PC官网" :value="10" />
                  <el-option label="桩到家微信服务号" :value="11" />
                  <el-option label="桩到家微信服务号菜单" :value="12" />
                  <el-option label="微信朋友圈" :value="13" />
                </el-select>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">购买名称：</div>
              <div class="cust-detail-value" v-if="
                detailForm.activityOrderInstallStatus ===
                'INVESTIGATION_INSTALL_FINISHED' ||
                detailForm.pileInstallCompletedTime != null
              ">
                <el-select v-model="detailForm.cableInstallMeterType" size="small" clearable
                  :disabled="detailForm.cableInstallMeterType != ''" class="full-width" placeholder="请选择购买名称">
                  <el-option label="家充无忧服务0米" value="0" />
                  <el-option label="家充无忧服务10米" value="10" />
                  <el-option label="家充无忧服务20米" value="20" />
                  <el-option label="家充无忧服务30米" value="30" />
                  <el-option label="家充无忧服务40米" value="40" />
                </el-select>
              </div>
              <div v-else>
                {{ "家充无忧服务" }}{{ detailForm.cableInstallMeterType
                }}<span v-if="detailForm.cableInstallMeterType != ''">米</span>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">解约下发状态：</div>
              <div class="cust-detail-value" style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                ">
                <div>
                  <span v-if="detailForm.enableCancelStatus === 'Y'">已下发</span>
                  <span v-if="detailForm.enableCancelStatus === 'N'">未下发</span>
                </div>
                <el-button type="text" size="small" @click="dialogVisible = true" :disabled="detailForm.enableCancelStatus === 'Y' ||
                  detailForm.activityOrderStatus !== 'TO_INSTALL'
                  ">
                  一键下发解约
                </el-button>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">订单状态：</div>
              <div class="cust-detail-value">
                {{
                  detailForm.activityOrderStatusName
                    ? detailForm.activityOrderStatusName
                    : "-"
                }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">已签约完成时间：</div>
              <div class="cust-detail-value">
                {{ detailForm.signTime || "-" }}
              </div>
            </el-col>

            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">已签约状态更新时间：</div>
              <div class="cust-detail-value">
                {{ detailForm.signedUpdateTime || "-" }}
              </div>
            </el-col>

            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">已签约预警状态：</div>
              <div class="cust-detail-value" :style="{
                color:
                  detailForm.signedWarningStatus === '正常'
                    ? '#67C23A'
                    : '#ea7281',
              }">
                {{ detailForm.signedWarningStatus }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">客服联系状态：</div>
              <div class="cust-detail-value">
                <el-select v-model="detailForm.activityOrderContractStatus" size="small" clearable class="full-width"
                  placeholder="请选择客服联系状态" @change="changContractStatus">
                  <el-option label="待联系" value="WAIT_CONTRACT" />
                  <el-option label="已联系" value="CONTRACTED" />
                  <el-option label="未联系上" value="NOT_CONTRACT" />
                </el-select>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">关联主服下单订单编号：</div>
              <div class="cust-detail-value">
                <el-input v-model="detailForm.pileInstallOrderNo" size="small" placeholder="请输入关联主服下单订单编号" :disabled="detailForm.activityOrderStatus == 'TO_SIGN' || detailForm.activityOrderStatus == 'COMMIT'" />
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">关联服务套餐配置ID：</div>
              <div class="cust-detail-value">
                <el-input v-model="detailForm.zeroPayConfigurationId" size="small" disabled />
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">安装状态：</div>
              <div class="cust-detail-value">
                <el-select v-model="detailForm.activityOrderInstallStatus" size="small" clearable class="full-width"
                  :disabled="detailForm.activityOrderInstallStatus ===
                    'INVESTIGATION_INSTALL_FINISHED'
                    " placeholder="请选择安装状态" @change="changeInstallStatus">
                  <el-option label="未勘察未安装" value="INVESTIGATION_INSTALL_INIT" />
                  <el-option label="已勘察已安装" value="INVESTIGATION_INSTALL_FINISHED" />
                  <el-option label="已勘察不安装" value="INVESTIGATION_FINISHED_NOT_INSTALL" />
                  <el-option label="未勘察不安装" value="INVESTIGATION_INIT_NOT_INSTALL" />
                </el-select>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">充电桩编码：</div>
              <div class="cust-detail-value">
                {{ detailForm.pileCode || "-" }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">充电桩安装完成时间：</div>
              <div class="cust-detail-value">
                <el-date-picker v-model="detailForm.pileInstallCompletedTime" type="datetime" placeholder="选择充电桩安装完成时间"
                  value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" size="small"></el-date-picker>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">充电桩资产编号：</div>
              <div class="cust-detail-value">
                ZDZC{{ detailForm.pileCode || "-" }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">充电桩使用状态：</div>
              <div class="cust-detail-value">
                {{
                  detailForm.activityOrder
                    ? detailForm.activityOrder.activateStatusName
                    : "-"
                }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">服务费用：</div>
              <div class="cust-detail-value">
                {{
                  detailForm.activityOrderCustomPrice && detailForm.activityOrderCustomPrice.servicePrice
                    ? detailForm.activityOrderCustomPrice.servicePrice : '--'
                }}
                元/度电
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">服务费状态：</div>
              <div class="cust-detail-value">
                <el-tag type="success" v-if="
                  detailForm.activityOrderCustomPrice &&
                  detailForm.activityOrderCustomPrice.priceActiveStatus ==
                  'ACTIVE'
                ">启用</el-tag>
                <el-tag type="danger" v-else>停用</el-tag>
              </div>
              <el-link type="primary" @click="dialogServiceFeeVisible = true">切换</el-link>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">服务费生效时间：</div>
              <div class="cust-detail-value">
                {{
                  detailForm.activityOrderCustomPrice
                    ? detailForm.activityOrderCustomPrice
                      .activationStartDatetime
                    : "-"
                }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">服务费截止时间：</div>
              <div class="cust-detail-value">
                {{
                  detailForm.activityOrderCustomPrice
                    ? detailForm.activityOrderCustomPrice.activationEndDatetime
                    : "-"
                }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">充电桩绑定激活时间：</div>
              <div class="cust-detail-value">
                {{
                  detailForm.activityOrder
                    ? detailForm.activityOrder.bindTime
                    : "-"
                }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">是否开通私桩共享：</div>
              <div class="cust-detail-value">
                {{
                  detailForm.pileShareConfig &&
                    detailForm.pileShareConfig === "Y"
                    ? "开启"
                    : detailForm.pileShareConfig === "N"
                      ? "不开启"
                      : "-"
                }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">是否开通过私桩共享</div>
              <div class="cust-detail-value">
                {{
                  detailForm.havePileShareConfig &&
                    detailForm.havePileShareConfig === "Y"
                    ? "开启"
                    : detailForm.havePileShareConfig === "N"
                      ? "不开启"
                      : "-"
                }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">充电桩最近充电时间：</div>
              <div class="cust-detail-value">
                {{
                  detailForm.activityOrder
                    ? detailForm.activityOrder.lastChargeTime
                    : "-"
                }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">充电桩到期时间：</div>
              <div class="cust-detail-value">
                {{
                  detailForm.activityOrder
                    ? detailForm.activityOrder.periodEndTime
                    : "-"
                }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">活动违约时间：</div>
              <div class="cust-detail-value">
                {{ detailForm.activityDefaultedTime || "-" }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">账单逾期时间：</div>
              <div class="cust-detail-value">
                {{ detailForm.activityAlipayOverdueTime || "-" }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">解约申请时间：</div>
              <div class="cust-detail-value">
                {{ detailForm.activityCancelApplicationTime || "-" }}
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">解约完成时间：</div>
              <div class="cust-detail-value">
                {{ detailForm.activityCancelCompletedTime || "-" }}
              </div>
            </el-col>

            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">芝麻免押状态：</div>
              <div class="cust-detail-value">
                {{ detailForm.sesameStatus == "Y" ? "已签约" : (detailForm.sesameStatus == "N" ? "已解约" : "未签约") }}
              </div>
            </el-col>

            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">关联主服拆桩订单编号：</div>
              <div class="cust-detail-value">
                <el-input v-model="detailForm.pileCancelOrderNo" size="small" placeholder="请输入关联主服拆桩订单编号" />
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">拆桩完成时间：</div>
              <div class="cust-detail-value">
                <el-date-picker v-model="detailForm.pileOrderCancelCompleteTime" type="datetime" placeholder="选择充拆桩完成时间"
                  value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 100%"></el-date-picker>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">是否有固定车位：</div>
              <div class="cust-detail-value">
                <el-select v-model="detailForm.activityOrder.parkSpace" size="small" clearable class="full-width"
                  placeholder="请选择是否有固定车位">
                  <el-option label="是" value="Y" />
                  <el-option label="否" value="N" />
                </el-select>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
              <div class="cust-detail-title">是否可提供联网环境：</div>
              <div class="cust-detail-value">
                <el-select v-model="detailForm.activityOrder.networkEnvironment" size="small" clearable
                  class="full-width" placeholder="请选择是否提供联网环境">
                  <el-option label="是" value="Y" />
                  <el-option label="否" value="N" />
                </el-select>
              </div>
            </el-col>

            <el-col :xs="16" :sm="16" :md="16" :lg="16" class="flex">
              <div class="cust-detail-title">省市区：</div>
              <div class="cust-detail-value" v-if="0">
                {{
                  detailForm.activityOrder
                    ? detailForm.activityOrder.province
                    : "-"
                }}
                -
                {{
                  detailForm.activityOrder ? detailForm.activityOrder.city : "-"
                }}
                -
                {{
                  detailForm.activityOrder ? detailForm.activityOrder.area : "-"
                }}
              </div>
              <Area :showLevel="3" @updateSelAreas="updateSelAreas" :selProvince="detailForm.activityOrder.province"
                :selCity="detailForm.activityOrder.city" :selArea="detailForm.activityOrder.area" />
            </el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" class="flex">
              <div class="cust-detail-title">详细地址：</div>
              <!-- <div class="cust-detail-value">{{ detailForm.activityOrder ? detailForm.activityOrder.address : '-' }}</div> -->
              <el-input v-model="detailForm.activityOrder.address" size="small" placeholder="请输入详细地址" />
            </el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" class="flex">
              <div class="cust-detail-title">备 注：</div>
              <el-input v-model="detailForm.activityOrder.remark" type="textarea" :rows="6" size="small" />
            </el-col>
          </el-row>
        </div>

        <!-- 服务账单明细 -->
        <div class="xy-table-div" v-if="selectItemFlag === '2'">
          <div class="xy-card-div">
            <div class="item-card">
              <div>
                <span>{{ zPayList.totalChargeOrder || "-" }}</span>笔
              </div>
              <div>累计充电订单数</div>
            </div>
            <div class="item-card">
              <div>
                <span>{{ zPayList.totalChargeElectricity || "-" }}</span>kwh
              </div>
              <div>累计充电电量</div>
            </div>
            <div class="item-card" v-if="0">
              <div>
                ￥<span>{{ zPayList.totalPaidHandlingFee || "-" }}</span>
              </div>
              <div>累计支付手续费</div>
            </div>
            <div class="item-card">
              <div>
                ￥<span>{{ zPayList.totalActualServiceFee || "-" }}</span>
              </div>
              <div>累计实收服务费</div>
            </div>
          </div>
          <div class="flex-r" style="
              margin-top: 20px;
              align-items: center;
              justify-content: space-between;
              border: 1px solid #ebeef5;
            ">
            <div style="display: flex">
              <div style="margin-left: 10px">
                <p class="margin-bottom-5 font-14">关键字搜索</p>
                <el-input clearable v-model="serviceQuery.searchKey" placeholder="请输入订单编号/支付流水号"></el-input>
              </div>

              <div style="margin-left: 30px">
                <p class="margin-bottom-5 font-14">账单创建时间</p>
                <div class="flex-r">
                  <el-date-picker v-model="serviceQuery.createFromTime" type="datetime" prefix-icon="el-icon-date"
                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" class="flex-1">
                  </el-date-picker>
                  <span class="time-query-line" style="line-height: 32px">-</span>
                  <el-date-picker v-model="serviceQuery.createToTime" type="datetime" prefix-icon="el-icon-date"
                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" class="flex-1">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div>
              <button class="common-bg-button" @click="searchServiceList()">
                搜 索
              </button>
              <button class="common-bg-button" @click="resetQuery()">
                重 置
              </button>
            </div>
          </div>
          <el-table class="el-table" :data="xPayList" border max-height="500px" style="width: 100%; margin: 20px auto"
            :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
              background: '#FAFAFA',
              color: '#8F9BB3',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #F0F0F0',
            }">
            <el-table-column width="240" prop="transactionId" label="支付流水号" />
            <el-table-column width="200" prop="pileOrderNo" label="充电订单编号" />
            <el-table-column width="200" prop="outTradeNo" label="商户订单编号" />
            <el-table-column width="200" prop="pileCode" label="充电桩编号">
              <template slot-scope="scope">
                {{ scope.row.pileOrder.pileCode || "-" }}
              </template>
            </el-table-column>
            <el-table-column width="240" prop="activityOrderNo" label="充电桩资产编号">
              <template slot-scope="scope">
                {{ "ZDZC" + scope.row.pileOrder.pileCode || "" }}
              </template>
            </el-table-column>
            <el-table-column width="200" prop="timeInterval" label="记录订单类型">
              <template slot-scope="scope">
                <span>{{
                  scope.row.recordOrderType === "COMMON_CHARGE_ORDER"
                    ? "正常充电订单"
                    : scope.row.recordOrderType === "SHARE_CHARGE_ORDER"
                      ? "私桩共享订单"
                      : scope.row.recordOrderType === "SERVICE_DEFAULT_FEE"
                        ? " 服务费违约订单"
                        : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column width="200" prop="name" label="用户姓名">
              <template slot-scope="scope">{{
                scope.row.activityOrder ? scope.row.activityOrder.name : "-"
              }}</template>
            </el-table-column>
            <el-table-column width="200" prop="mobile" label="用户手机号">
              <div slot="header" style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                ">
                <span style="margin-right: 8px">用户手机号</span>
                <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_隐藏.png" alt=""
                  v-if="!isFlag" @click="flagChange()" />
                <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_显示.png" alt=""
                  v-if="isFlag" @click="flagChange()" />
              </div>
              <template slot-scope="scope">
                <span v-if="isFlag">{{
                  scope.row.activityOrder.mobile || "-"
                }}</span>
                <span v-else>{{
                  scope.row.activityOrder.mobile
                    ? scope.row.activityOrder.mobile.replace(
                      scope.row.activityOrder.mobile.substring(2, 9),
                      "*******"
                    )
                    : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column width="200" prop="province" label="省">
              <template slot-scope="scope">{{
                scope.row.activityOrder ? scope.row.activityOrder.province : "-"
              }}</template>
            </el-table-column>
            <el-table-column width="200" prop="city" label="市">
              <template slot-scope="scope">{{
                scope.row.activityOrder ? scope.row.activityOrder.city : "-"
              }}</template>
            </el-table-column>
            <el-table-column width="200" prop="area" label="区">
              <template slot-scope="scope">{{
                scope.row.activityOrder ? scope.row.activityOrder.area : "-"
              }}</template>
            </el-table-column>
            <el-table-column width="300" prop="address" label="详细地址">
              <template slot-scope="scope">{{
                scope.row.activityOrder ? scope.row.activityOrder.address : "-"
              }}</template>
            </el-table-column>
            <el-table-column width="200" prop="" label="服务费类别">
              <template slot-scope="scope">
                <span v-if="scope.row.withHoldType === 'BASIC_SERVICE'">{{
                  "基础服务费"
                }}</span>
                <span v-if="scope.row.withHoldType === 'TECHNICAL_SERVICE'">{{
                  "技术服务费"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column width="200" prop="serverPrice" label="服务费价格（元）">
              <template slot-scope="scope">{{
                scope.row.serverPrice || "-"
              }}</template>
            </el-table-column>
            <el-table-column width="200" prop="chargeVal" label="充电电量">
              <template slot-scope="scope">
                {{ scope.row.pileOrder.chargeVal || "-" }}
              </template>
            </el-table-column>
            <el-table-column width="200" prop="" label="充电开始时间">
              <template slot-scope="scope">{{
                scope.row.pileOrder.beginTime || "-"
              }}</template>
            </el-table-column>
            <el-table-column width="200" prop="" label="充电结束时间">
              <template slot-scope="scope">{{
                scope.row.pileOrder.endTime || "-"
              }}</template>
            </el-table-column>
            <el-table-column width="200" prop="feePayAmount" label="应收服务费" />
            <el-table-column width="200" prop="actPayAmount" label="平台实收服务费" />
            <el-table-column width="200" prop="walletListUserAmount" label="用户实付服务费" />
            <el-table-column width="200" prop="walletListDiscountAmount" label="支付宝折扣服务费" />
            <el-table-column width="200" prop="refundAmount" label="已退平台实收服务费" />
            <el-table-column width="200" prop="useRefundAmount" label="已退用户实付服务费" />
            <el-table-column width="200" prop="discountRefundAmount" label="已退支付宝折扣服务费" />
            <el-table-column width="200" prop="walletListDiscountAmount" label="服务费折扣(元)" align="center" />
            <el-table-column width="200" prop="refundAmount" label="已退实收服务费（元）" />
            <el-table-column width="200" prop="" label="账单状态">
              <template slot-scope="scope">
                {{
                  scope.row.orderPayStatus === "CHARGE_BACKS"
                    ? "已支付"
                    : scope.row.orderPayStatus === "CHARGE_LATE"
                      ? "已逾期"
                      : scope.row.orderPayStatus === "CHARGE_COMPLIANCE"
                        ? "待守约"
                        : scope.row.orderPayStatus === "CHARGE_REFUND"
                          ? "已退款"
                          : ""
                }}
              </template>
            </el-table-column>
            <el-table-column width="200" prop="orderPayFunction" label="支付方式">
              <template slot-scope="scope">
                <span v-if="scope.row.orderPayFunction === 'SESAME_PLATFORM_WITH_HOLD'">商家代扣</span>
                <span v-else-if="scope.row.orderPayFunction === 'PAY_MANUAL'">手动支付</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column prop="payTime" label="支付完成时间" width="200" align="center" />
            <el-table-column width="200" prop="orderPayResult" label="支付结果">
              <template slot-scope="scope">
                {{
                  scope.row.orderPayResult === "PAID_SUCCESS"
                    ? "支付成功"
                    : scope.row.orderPayResult === "PAID_FAIL"
                      ? "支付失败"
                      : ""
                }}
              </template>
            </el-table-column>
            <el-table-column width="200" prop="createdWhen" label="账单创建时间" />
            <el-table-column width="200" prop="refundOperateTime" label="退款操作时间" />
            <el-table-column width="200" prop="refundFinishTime" label="退款完成时间" />
            <el-table-column width="200" prop="refundReason" label="退款原因" />
            <el-table-column width="200" prop="refundRemark" label="退款原因备注" />
            <el-table-column width="200" prop="refundType" label="退款类型">
              <template slot-scope="scope">
                <span>{{
                  scope.row.refundType === "ALL"
                    ? "全额退款"
                    : scope.row.refundType === "PART"
                      ? "部分退款"
                      : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column width="200" prop="refundWay" label="退款方式">
              <template slot-scope="scope">
                <span>{{
                  scope.row.refundWay === "AGREEMENT"
                    ? "商户代扣"
                    : scope.row.refundWay === "MANUAL"
                      ? "手动退款"
                      : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column width="200" prop="refundResult" label="退款结果">
              <template slot-scope="scope">
                <span>{{
                  scope.row.refundResult === "Y"
                    ? "成功"
                    : scope.row.refundResult === "N"
                      ? "失败"
                      : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column width="200" prop="refundByName" label="退款操作人" />
            <el-table-column width="200" prop="" label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="handleRefund(scope.row)">退 款</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="list-pagination">
            <ZD-pagination :pagination="pagination" v-on:pageUpdate="getZeropayList" />
          </div>
        </div>

        <!-- 解约（买断/退出）申请记录 -->
        <div class="xy-table-div" v-if="selectItemFlag === '3'">
          <el-table class="el-table" :data="yPayList" border max-height="500px" style="width: 100%; margin: 20px auto"
            :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
              background: '#FAFAFA',
              color: '#8F9BB3',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #F0F0F0',
            }">
            <el-table-column width="200" prop="cancelType" label="解约类型">
              <template slot-scope="scope">
                {{
                  scope.row.cancelType === "BUY_OUT"
                    ? "解约（买断）"
                    : scope.row.cancelType === "REFUND"
                      ? "解约（退出）"
                      : scope.row.cancelType === "DEFAULT"
                        ? "违约"
                        : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column width="240" prop="activityOrderNo" label="解约订单编号" />
            <el-table-column width="200" prop="cancelRequestTime" label="解约申请时间" />
            <el-table-column width="200" prop="cancelFinishTime" label="解约完成时间" />
            <el-table-column width="200" prop="cancelAmount" label="解约金额（元）" />
            <el-table-column width="200" prop="depreciationNetPrice" label="折旧后设备净值（元）" />
            <el-table-column width="200" prop="payedServiceAmount" label="已支付服务费（元）" />
            <el-table-column width="200" prop="disassemblyPrice" label="拆桩服务费（元）" />
            <el-table-column width="200" prop="payMethod" label="支付渠道">
              <template slot-scope="scope">
                {{
                  scope.row.payMethod === "ALIPAY"
                    ? "支付宝"
                    : scope.row.payMethod === "WECHAT_PAY"
                      ? "微信支付"
                      : scope.row.payMethod === "ALIPAY_SESAME"
                        ? "支付宝免押"
                        : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column width="200" prop="paySuccessDatetime" label="支付时间" />
            <el-table-column width="200" prop="cancelApplicationStatus" label="解约申请状态">
              <template slot-scope="scope">
                {{
                  scope.row.cancelApplicationStatus === "APPLICATION"
                    ? "已申请"
                    : scope.row.cancelApplicationStatus === "LAPSE"
                      ? "已失效"
                      : scope.row.cancelApplicationStatus === "FINISHED"
                        ? "已完成"
                        : scope.row.cancelApplicationStatus === "CANCELED"
                          ? "已取消"
                          : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column width="200" prop="cancelReason" label="解约原因" />
          </el-table>
        </div>
        <!-- 服务费设置记录 -->
        <div class="xy-table-div" v-if="selectItemFlag === '4'">
          <el-table class="el-table" :data="xyPayList" border max-height="500px" style="width: 100%; margin: 20px auto"
            :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
              background: '#FAFAFA',
              color: '#8F9BB3',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #F0F0F0',
            }">
            <el-table-column prop="priceActiveStatus" label="服务费状态">
              <template slot-scope="scope">
                {{ scope.row.priceActiveStatus === "ACTIVE" ? "启用" : "停用" }}
              </template>
            </el-table-column>
            <el-table-column prop="servicePrice" label="服务费用（元）" />
            <el-table-column prop="priceStartDateTime" label="服务费生效时间" />
            <el-table-column prop="priceEndDateTime" label="服务费截止时间" />
            <el-table-column prop="priceType" label="有效期类型">
              <template slot-scope="scope">
                {{ scope.row.priceType === "CUSTOM" ? "自定义" : "默认" }}
              </template>
            </el-table-column>
            <el-table-column prop="autoSettingFlag" label="是否自动设置">
              <template slot-scope="scope">
                {{ scope.row.autoSettingFlag === "Y" ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column prop="priceActiveStatus" label="设置类型">
              <template slot-scope="scope">
                {{ scope.row.priceActiveStatus === "ACTIVE" ? "启用" : "停用" }}
              </template>
            </el-table-column>
            <el-table-column prop="configUserName" label="设置人" />
            <el-table-column prop="configUserMobile" label="设置账号" />
            <el-table-column prop="configDateTime" label="设置创建时间" />
          </el-table>
          <!-- 分页 -->
          <div class="list-pagination">
            <ZD-pagination :pagination="pagination" v-on:pageUpdate="getserviceFreeDetail" />
          </div>
        </div>
        <!-- 换桩记录 -->
        <div class="xy-table-div" v-if="selectItemFlag === '5'">
          <PileSwapRecordTable :activityorderNo="detailForm.activityOrderNo" @refresh="init" />
        </div>
        <el-dialog title="请确认是否需要下发解约" :visible.sync="dialogVisible" width="30%">
          <span>下发后用户将自动解约，退出活动！</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleClickEnable">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 退款弹窗 -->
        <el-dialog :title="popInfoText" :visible.sync="dialogRefundVisible" width="30%"
          @closed="handleClose('ruleForm')">
          <div v-if="popFormInfo.refundAmount" style="display: flex; flex-direction: column">
            <el-form :model="popFormInfo" :rules="popFromRules" ref="ruleForm" label-width="130px"
              class="demo-ruleForm">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="退款支付宝账户:" style="width: 100%">
                    <el-input v-model="popFormInfo.userPhone" size="small" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="退款金额:" style="width: 100%">
                    <el-input-number v-model="popFormInfo.refundAmount" size="small" :min="0" :max="popFormInfo.refundAmount ? popFormInfo.refundAmount : 0
                      " />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="退款类型:" prop="refundType" style="width: 100%">
                    <el-select v-model="popFormInfo.refundType" size="small" style="width: 100%">
                      <el-option label="全额退款" value="ALL" />
                      <el-option label="部分退款" value="PART" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="退款原因:" prop="refundReason" style="width: 100%">
                    <el-select v-model="popFormInfo.refundReason" size="small" style="width: 100%">
                      <el-option label="平台测算" value="平台测算" />
                      <el-option label="用户申请" value="用户申请" />
                      <el-option label="其他" value="其他" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="popFormInfo.refundReason == '其他'">
                  <el-form-item label="" style="width: 100%">
                    <el-input v-model="popFormInfo.refundRemark" size="small" type="textarea" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

          <div v-else>参与服务的免押订单暂不支持退款</div>

          <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose('ruleForm')">取 消</el-button>
            <el-button v-if="popFormInfo.refundAmount" type="primary" @click="makeSure('ruleForm')">确定退款</el-button>
          </span>
        </el-dialog>
        <!-- 服务费编辑弹框 -->
        <el-dialog title="服务费状态设置" :visible.sync="dialogServiceFeeVisible" width="35%"
          @closed="handleClose('ruleForm')">
          <div style="display: flex; flex-direction: column">
            <el-form :model="popFormInfos" :rules="popFromRuless" ref="ruleForms" label-width="130px"
              class="demo-ruleForm">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="服务费状态:" style="width: 100%">
                    <el-switch v-model="serviceFreeFlag" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="服务费价格设置:" style="width: 100%" prop="servicePrice">
                    <div style="display: flex">
                      <div>
                        <el-input-number v-model="popFormInfos.servicePrice" size="small" :min="0" />
                      </div>
                      <div>元/度电</div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="设置有效期:" style="width: 100%">
                    <el-col :span="11">
                      <el-form-item prop="activationStartDatetime">
                        <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"
                          v-model="popFormInfos.activationStartDatetime" type="datetime" placeholder="选择开始时间"
                          @change="validateTimeRanges">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2">-</el-col>
                    <el-col :span="11">
                      <el-form-item prop="activationEndDatetime">
                        <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="popFormInfos.activationEndDatetime"
                          type="datetime" placeholder="选择结束时间" @change="validateTimeRange">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                </el-col>
                <el-col :span="24">有效期结束后将自动恢复默认状态</el-col>
              </el-row>
            </el-form>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogServiceFeeVisible = false">取 消</el-button>
            <el-button type="primary" @click="makeSures('ruleForms')">确定保存</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import Area from "../../../components/area-select/index.vue";
import PileSwapRecordTable from "./pile-swap-record-table.vue";
import { pcaTextArr } from "element-china-area-data"; //导入地图数据
export default {
  components: {
    Area,
    PileSwapRecordTable,
  },
  data() {
    return {
      serviceQuery: {
        createToTime: "",
        createFromTime: "",
        searchKey: "",
      },
      options: pcaTextArr,
      activityOrderId: "",
      tableData: [], // 表格数据
      pagination: pageConfig.pagination,
      detailBreadCrumb: pageConfig.detailBreadCrumb,
      selectListArr: [
        {
          label: "订单基本信息",
          value: "1",
        },
        {
          label: "服务账单明细",
          value: "2",
        },
        {
          label: "解约（买断/退出）申请记录",
          value: "3",
        },
        {
          label: "服务费设置记录",
          value: "4",
        },
        {
          label: "换桩记录",
          value: "5",
        },
      ],
      selectItemFlag: "1",
      // 默认值设置
      detailForm: {
        selectedOptions: [],
        activityOrder: {
          province: "",
          city: "",
          area: "",
          address: "",
        },
      },
      xPayList: [], // 服务账单明细
      yPayList: [], // 解约申请记录
      zPayList: {},
      xyPayList: [],
      isFlag: false,
      dialogVisible: false,

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },

      dialogRefundVisible: false,
      dialogServiceFeeVisible: false,
      popInfoText: "",
      popFormInfo: {
        refundReason: "",
        refundRemark: "",
        refundType: "",
      },
      popFormInfos: {},
      serviceFreeFlag: false,
      popFromRules: {
        refundType: [
          { required: true, message: "请选择退款类型", trigger: "change" },
        ],
        refundReason: [
          { required: true, message: "请选择退款原因", trigger: "change" },
        ],
        refundRemark: [
          { required: true, message: "请输入退款原因", trigger: "change" },
        ],
      },
      popFromRuless: {
        priceActiveStatus: [
          { required: true, message: "请选择服务费状态", trigger: "change" },
        ],
        servicePrice: [
          { required: true, message: "请选择服务费价格", trigger: "change" },
        ],
        activationStartDatetime: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        activationEndDatetime: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    resetQuery() {
      this.serviceQuery = {
        createToTime: "",
        createFromTime: "",
        searchKey: "",
      };
      this.xPayList = [];
      this.getZeropayList(this.getZeropayList, true);
    },
    searchServiceList() {
      this.xPayList = [];
      this.getZeropayList(this.getZeropayList, true);
    },
    signChage() {
      console.log(this.detailForm.signFlag);
      if (this.detailForm.signFlag == "Y") {
        let result = this.validateAddress(this.detailForm);
        console.log(result);
        if (!result) {
          this.$U.error("请完善省市区和详细地址");
        }
      }
    },
    validateTimeRange() {
      const start = new Date(this.popFormInfos.activationStartDatetime);
      const end = new Date(this.popFormInfos.activationEndDatetime);

      // 检查两个日期是否都有效
      if (isNaN(start.getTime()) || isNaN(end.getTime())) {
        this.timeError = "";
        return;
      }

      // 验证结束时间大于开始时间
      if (end <= start) {
        this.$U.error("结束时间必须大于开始时间");
        this.popFormInfos.activationStartDatetime = "";
      } else {
        this.timeError = "";
      }
    },
    validateTimeRanges() {
      console.log(33333);
      console.log(this.popFormInfos.activationEndDatetime);
      if (
        this.popFormInfos.activationEndDatetime != "" ||
        this.popFormInfos.activationEndDatetime != null
      ) {
        const start = new Date(this.popFormInfos.activationStartDatetime);
        const end = new Date(this.popFormInfos.activationEndDatetime);
        console.log(11111111);
        // 检查两个日期是否都有效
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
          this.timeError = "";
          return;
        }

        // 验证结束时间大于开始时间
        if (end <= start) {
          this.$U.error("结束时间必须大于开始时间");
          console.log(99999);
        } else {
          console.log(8888);
          this.$U.error("开始时间必须大于结束时间");
          this.popFormInfos.activationEndDatetime = "";
        }
      }
    },
    validateAddress(detailForm) {
      const province = detailForm?.activityOrder?.province?.trim();
      const city = detailForm?.activityOrder?.city?.trim();
      const area = detailForm?.activityOrder?.area?.trim();
      const address = detailForm?.activityOrder?.address?.trim();
      return !!(province && city && area && address);
    },
    flagChange() {
      this.isFlag = !this.isFlag;
    },

    handleClickItem(row) {
      let _ = this;
      _.selectItemFlag = row.value;
      if (row.value === "1") _.init();
      if (row.value === "2") _.getZeropayList(_.getZeropayList, true);
      if (row.value === "3") _.getZeropayDetail();
      if (row.value === "4") _.getserviceFreeDetail();
    },

    init() {
      let _ = this;
      _.activityOrderId = _.$route.query.id;
      _.$H.get(_, _.$A.zeropay.detail + _.activityOrderId).then((res) => {
        _.detailForm = res.data.data || {};
        _.popFormInfos = JSON.parse(
          JSON.stringify(res.data.data.activityOrderCustomPrice || {})
        );
        if (_.popFormInfos.priceActiveStatus == "ACTIVE") {
          _.serviceFreeFlag = true;
        } else {
          _.serviceFreeFlag = false;
        }
        // if (this.detailForm.city == this.detailForm.province) {
        //   this.detailForm.city = "市辖区";
        // }
        if (this.detailForm.city == "市辖区") {
          this.detailForm.city = this.detailForm.province;
        }
        //  城市文字转编码
        if (this.detailForm.province != "" && this.detailForm.city != "") {
          this.detailForm.selectedOptions = [
            this.detailForm.province,
            this.detailForm.city,
            this.detailForm.area,
          ];
        }
        _.$U.hideLoading(_);
      });
    },

    // 确认一键解约
    handleClickEnable() {
      let _ = this;
      const activityOrderNo = _.$route.query.activityOrderNo;
      _.$H
        .post(_, _.$A.zeropay.cancelStatus, {
          activityOrderNo: activityOrderNo,
          enableCancelStatus: "Y",
        })
        .then((res) => {
          _.dialogVisible = false;
          _.init();
        });
    },
    updateSelAreas(val) {
      console.log(val);
      this.detailForm.activityOrder.province = val.province;
      this.detailForm.activityOrder.city = val.city;
      this.detailForm.activityOrder.area = val.area;
    },
    // 服务账单
    getZeropayList(pagination, reload = false) {
      let _ = this;

      const activityOrderNo = _.$route.query.activityOrderNo;

      // 服务账单明细 - 统计
      _.$H
        .post(_, _.$A.zeropay.countList, { activityOrderNo: activityOrderNo })
        .then((res) => {
          _.zPayList = res.data.data || {};
        });
      let params = {
        pageNum: pagination.current - 1,
        activityOrderNo: activityOrderNo,
        pageSize: _.pagination.pageSize,
        ..._.serviceQuery,
      };
      if (reload) {
        _.pagination.current = 1;
        params.pageNum = 0;
      }
      // 服务账单明细
      _.$H.post(_, _.$A.zeropay.orderDetail, params).then((res) => {
        _.xPayList = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
      });
    },

    // 解约账单
    getZeropayDetail() {
      let _ = this;

      const activityOrderNo = _.$route.query.activityOrderNo;

      // 解约申请记录
      _.$H
        .post(_, _.$A.zeropay.cancelOrderRecord, {
          activityOrderNo: activityOrderNo,
        })
        .then((res) => {
          _.yPayList = res.data.data || {};
        });
    },
    // 服务费设置记录
    getserviceFreeDetail(pagination) {
      let _ = this;

      const activityOrderNo = _.$route.query.activityOrderNo;

      _.$H
        .post(_, _.$A.zeropay.serviceFreeList, {
          activityOrderNo: activityOrderNo,
          pageSize: _.pagination.pageSize,
          pageNum: _.pagination.current - 1,
        })
        .then((res) => {
          _.xyPayList = res.data.data.content || {};
          _.pagination.total = res.data.data.totalElements || 0;
        });
    },
    // 客服联系状态
    changContractStatus(val) {
      let _ = this;
      if (val) {
        if (val === "WAIT_CONTRACT")
          _.detailForm.activityOrderContractStatusName = "待联系";
        if (val === "CONTRACTED")
          _.detailForm.activityOrderContractStatusName = "已联系";
        if (val === "NOT_CONTRACT")
          _.detailForm.activityOrderContractStatusName = "未联系上";
      }
    },
    // 安装状态
    changeInstallStatus(val) {
      let _ = this;
      if (val) {
        if (val === "INVESTIGATION_INSTALL_INIT")
          _.detailForm.activityOrderInstallStatusName = "未勘察未安装";
        if (val === "INVESTIGATION_INSTALL_FINISHED")
          _.detailForm.activityOrderInstallStatusName = "已勘察已安装";
        if (val === "INVESTIGATION_FINISHED_NOT_INSTALL")
          _.detailForm.activityOrderInstallStatusName = "已勘察不安装";
        if (val === "INVESTIGATION_INIT_NOT_INSTALL")
          _.detailForm.activityOrderInstallStatusName = "未勘察不安装";
      }
    },

    //修改订单金额
    submit() {
      let _ = this;
      if (this.detailForm.signFlag == "Y") {
        let result = this.validateAddress(this.detailForm);
        if (!result) {
          this.$U.error("请完善省市区和详细地址");
          return;
        }
      }
      if (
        this.detailForm.activityOrderInstallStatus ==
        "INVESTIGATION_INIT_NOT_INSTALL"
      ) {
        // 未勘察不安装
        if (
          this.detailForm.installFailReason == "" ||
          this.detailForm.installFailReason == null
        ) {
          this.$U.error("请选择不安装原因");
          return;
        }
      }

      if (
        this.detailForm.activityOrderInstallStatus ==
        "INVESTIGATION_INSTALL_FINISHED"
      ) {
        // 已勘察已安装
        if (
          this.detailForm.pileInstallCompletedTime == "" ||
          this.detailForm.pileInstallCompletedTime == null
        ) {
          this.$U.error("请选择充电桩安装完成时间");
          return;
        }
        // if (
        //   this.detailForm.cableInstallMeterType == "" ||
        //   this.detailForm.cableInstallMeterType == null
        // ) {
        //   this.$U.error("请选择购买名称");
        //   return;
        // }
      }

      if (
        this.detailForm.activityOrderInstallStatus ==
        "INVESTIGATION_FINISHED_NOT_INSTALL"
      ) {
        // 已勘察不安装
        // if (
        //   this.detailForm.installFailReason == "" ||
        //   this.detailForm.installFailReason == null
        // ) {
        //   this.$U.error("请选择不安装原因");
        //   return;
        // }
        // if (
        //   this.detailForm.pileInstallCompletedTime == "" ||
        //   this.detailForm.pileInstallCompletedTime == null
        // ) {
        //   this.$U.error("请选择充电桩安装完成时间");
        //   return;
        // }

        if (this.detailForm.activityOrderStatus == "IN_SIGN") {
          // 已签约
          if (
            this.detailForm.pileInstallOrderNo == "" ||
            this.detailForm.pileInstallOrderNo == null
          ) {
            this.$U.error("请输入关联主服下单订单编号");
            return;
          }
        }
        if (this.detailForm.activityOrderStatus == "TO_INSTALL") {
          // 待安装
          if (this.detailForm.enableCancelStatus != "Y") {
            this.$U.error("请先下发一键解约");
            return;
          }
        }
      }
      _.$H.post(_, _.$A.zeropay.edit, _.detailForm).then((res) => {
        _.$U.success("修改成功！");
        _.$router.push({
          name: "activityOrderZreoList",
        });
      });
    },
    back() {
      this.$router.go(-1);
    },

    // 退款操作
    handleRefund(row) {
      let _ = this;
      console.log(row);
      if (row.refundResult == "Y") {
        _.$U.success("已退款成功");
        return;
      }
      if (row.orderStatus == "TO_REFUND") {
        this.$U.success("退款中耐心等待");
        return;
      }
      _.popInfoText = "退款金额确认";
      _.popFormInfo.userPhone = row.activityOrder.mobile;
      _.popFormInfo.activityOrderNo = row.activityOrderNo;
      _.popFormInfo.refundAmount = row.actPayAmount || 0;
      _.popFormInfo.pileOrderNo = row.pileOrderNo;
      _.popFormInfo.transactionId = row.transactionId;
      _.dialogRefundVisible = true;
    },
    makeSure(formName) {
      let _ = this;
      _.$refs[formName].validate((valid) => {
        if (valid) {
          _.$H
            .post(_, _.$A.zeropay.orderDetailRefund, _.popFormInfo)
            .then((res) => {
              _.dialogRefundVisible = false;
              _.$U.success("退款成功");
              _.init();
            });
        }
      });
    },
    makeSures(formName) {
      let _ = this;
      if (
        this.popFormInfos.activationStartDatetime &&
        this.popFormInfos.activationEndDatetime
      ) {
        console.log(11111);
        const start = new Date(this.popFormInfos.activationStartDatetime);
        const end = new Date(this.popFormInfos.activationEndDatetime);
        if (end <= start) {
          this.$U.error("结束时间必须大于开始时间");
          return;
        }
      }
      _.$refs[formName].validate((valid) => {
        if (valid) {
          _.popFormInfos.priceActiveStatus = _.serviceFreeFlag
            ? "ACTIVE"
            : "INACTIVE";
          _.popFormInfos.activityOrderNo = _.$route.query.activityOrderNo;
          _.$H.post(_, _.$A.zeropay.serviceFree, _.popFormInfos).then((res) => {
            _.dialogServiceFeeVisible = false;
            _.$U.success("服务费设置成功");
            _.init();
          });
        }
      });
    },
    // 关闭 - 退款提示
    handleClose(formName) {
      let _ = this;
      _.popInfoText = "请知晓";
      _.dialogRefundVisible = false;
      _.$refs[formName].resetFields();
    },
    // 发起售后换桩
    onPileSwapInitiate() {
      const _ = this;
      _.$confirm('确认发起售后换桩?发起后活动状态将变为"换桩中",用户需在小程序解绑旧桩并绑定新桩。', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',
      }).then(() => {
        _.$H.post(_, _.$A.activityOrder.axbPileSwapInitiate, {
          activityOrderNo: _.detailForm.activityOrderNo,
        }).then((res) => {
          if (res && res.data && res.data.status === 200) {
            _.$message.success('已发起换桩');
            _.init();
          } else {
            _.$message.error((res && res.data && res.data.message) || '发起换桩失败');
          }
        }).catch(() => _.$message.error('发起换桩失败'));
      }).catch(() => {});
    },
    // 取消换桩
    onPileSwapCancel() {
      const _ = this;
      _.$confirm('确认取消换桩?取消后将恢复活动为换桩前的状态。', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',
      }).then(() => {
        _.$H.post(_, _.$A.activityOrder.axbPileSwapCancel, {
          activityOrderNo: _.detailForm.activityOrderNo,
        }).then((res) => {
          if (res && res.data && res.data.status === 200) {
            _.$message.success('已取消换桩');
            _.init();
          } else {
            _.$message.error((res && res.data && res.data.message) || '取消换桩失败');
          }
        }).catch(() => _.$message.error('取消换桩失败'));
      }).catch(() => {});
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
.title-div {
  font-weight: 600;
  margin: 10px 0 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}

.top-select-title {
  font-weight: 600;
  font-size: 20px;
  color: #000;
  margin-bottom: 40px;
  margin-right: 48px;
  cursor: pointer;
}

.active {
  color: #4182eb;
}

.pileItem-div {
  font-weight: 600;
  //   margin: 0 10px !important;
  font-size: 20px;
  // flex-grow: 1;
  color: #000;
  // height: 30px;
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    width: 160px;
    line-height: 32px;
  }

  >div:last-of-type {
    flex: 1;
    font-size: 14px;
    min-width: 160px;
    line-height: 32px;
  }
}

.cust-detail-title {
  width: 160px;
  line-height: 32px;
  font-weight: 700;
}

.cust-detail-value {
  flex: 1;
  line-height: 32px;
  word-break: break-all;
  display: flex;
  // justify-content: center;
  align-items: center;
}

.margin-r-10 {
  margin-right: 10px;
}

.flex-orderno-line-div {
  display: flex;
  border-bottom: 1px solid #555;
  padding-bottom: 16px;
  margin-bottom: 16px;

  .line-child-order-no-title {
    font-weight: 600;
    font-size: 26px;
    color: #000;
    height: 30px;
    margin-right: 60px;
  }

  .line-child-order-no-value {
    font-weight: 600;
    font-size: 26px;
    color: #000;
    height: 30px;
    flex: 1;
  }
}

.padding-top-10 {
  padding-top: 10px;
}

.xy-card-div {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 16px;
  box-sizing: border-box;

  border: 1px solid #ddd;
  border-radius: 16px;

  margin-top: 16px;

  .item-card {
    width: calc(100% / 4);
    display: flex;
    flex-direction: column;
    align-items: center;

    border-right: 1px solid #ddd;

    div:first-child {
      line-height: 32px;

      span {
        font-size: 24px;
        line-height: 32px;
        margin: 0 16px;
      }
    }
  }

  .item-card:last-child {
    border-right: none;
  }
}
</style>
